import React from "react";
import ReactDOM from "react-dom";

export default function PostWarningModal({ open, onContinue, onCancel }) {
  if (!open) return null;

  return ReactDOM.createPortal(
    (
      <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[9999] px-4">
        <div className="bg-white rounded-xl p-6 max-w-sm w-full shadow-xl">
          <h2 className="text-xl font-bold text-gray-800 mb-3 text-center">
            Before You Post
          </h2>

          <p className="text-sm text-gray-700 text-center mb-4">
            Recettes is a <strong>strict food-only</strong> platform.
            Please confirm your post is related to:
          </p>

          <ul className="text-sm text-gray-700 mb-4 space-y-1">
            <li>• Recipes</li>
            <li>• Food hacks &amp; kitchen tips</li>
            <li>• Cooking tutorials</li>
            <li>• Ingredients &amp; kitchen tools</li>
            <li>• Restaurants or meals</li>
          </ul>

          <p className="text-xs text-gray-600 text-center">
            Unrelated content or NSFW posts may result in warnings or account bans.
          </p>

          <div className="flex gap-3 mt-6">
            <button
              onClick={onCancel}
              className="w-1/2 py-2 rounded-full border border-gray-300 text-gray-700 font-semibold"
            >
              Cancel
            </button>

            <button
              onClick={onContinue}
              className="w-1/2 bg-orange-500 hover:bg-orange-600 text-white py-2 rounded-full font-semibold"
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    ),
    document.body
  );
}
